var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.125H2C1.90054 3.125 1.80516 3.16451 1.73483 3.23483C1.66451 3.30516 1.625 3.40054 1.625 3.5V12C1.625 12.2321 1.71719 12.4546 1.88128 12.6187C2.04538 12.7828 2.26794 12.875 2.5 12.875H13.5C13.7321 12.875 13.9546 12.7828 14.1187 12.6187C14.2828 12.4546 14.375 12.2321 14.375 12V3.5C14.375 3.40054 14.3355 3.30516 14.2652 3.23483C14.1948 3.16451 14.0995 3.125 14 3.125ZM13.0363 3.875L8 8.49125L2.96375 3.875H13.0363ZM13.5 12.125H2.5C2.46685 12.125 2.43505 12.1118 2.41161 12.0884C2.38817 12.0649 2.375 12.0332 2.375 12V4.3525L7.75 9.27625C7.81913 9.33949 7.90943 9.37457 8.00313 9.37457C8.09682 9.37457 8.18712 9.33949 8.25625 9.27625L13.625 4.3525V12C13.625 12.0332 13.6118 12.0649 13.5884 12.0884C13.5649 12.1118 13.5332 12.125 13.5 12.125Z",
    fill: "#CC972F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e3853547134da434d0df8d88e44141b2.svg";
export { ForwardRef as ReactComponent };